/**
 * Structured API error surfaced by ApiClient when the server returns a
 * non-2xx response or a { ok: false } envelope.
 *
 * code    — machine-readable error code from the API (e.g. 'validation_error', 'session_expired')
 * message — human-readable message suitable for display
 * fieldErrors — optional map of field-name → error message (validation failures)
 * status  — HTTP status code of the response
 */
export class ApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly fieldErrors?: Record<string, string>,
    public readonly status?: number
  ) {
    super(message);
    this.name = 'ApiError';
    // Restore prototype chain for instanceof checks across transpilation targets
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
